import { Controller } from "stimulus";
export default class extends Controller {
  static targets = ["gridBtn", "galleryBtn", "thumbnail", "thumbnailsInner", "thumbnailsContainer"];

  connect() {
    this.thumbnailTargets.forEach(thumbnail => {
      thumbnail.addEventListener('click', this.scrollToCenter.bind(this));
    });
  }

  openOverlay() {
    this.gridBtnTarget.classList.add("active");
    this.galleryBtnTarget.classList.remove("active");
    this.element.classList.add("grid-mode");
    this.element.classList.add("open");
    document.body.style.overflowY = "hidden";
  }

  scrollToCenter(event) {
    const thumbnail = event.currentTarget;
    const thumbnailsInner = this.thumbnailsContainerTarget;
    const thumbnailRect = thumbnail.getBoundingClientRect();
    const innerRect = thumbnailsInner.getBoundingClientRect();
    const offset = thumbnailRect.left + thumbnailsInner.scrollLeft - innerRect.left - (innerRect.width / 2) + (thumbnailRect.width / 2);

    thumbnailsInner.scrollTo({
      left: offset,
      behavior: 'smooth'
    });

  }

  setSlider({ currentTarget }) {
    const gridItems = Array.from(this.element.querySelectorAll(`.grid-block`));
    const glideItems = Array.from(
      this.element.querySelectorAll(`.glide .thumbnail`)
    );

    const idx = gridItems.indexOf(currentTarget);

    glideItems[idx].click();
  }

  /* eslint-disable-next-line no-unused-vars */
  galleryMode(e) {
    this.gridBtnTarget.classList.remove("active");
    this.galleryBtnTarget.classList.add("active");
    this.element.classList.remove("grid-mode");
    // since the slider is inited while the gallery is hidden, we trigger a
    // resize event on the window to re-initialize the slider so it shows
    const resize = new CustomEvent("resize");
    window.dispatchEvent(resize);
  }

  /* eslint-disable-next-line no-unused-vars */
  gridMode(e) {
    this.gridBtnTarget.classList.add("active");
    this.galleryBtnTarget.classList.remove("active");
    this.element.classList.add("grid-mode");
  }

  next() {
    this.element.querySelector(".right-arrow").click();
  }

  previous() {
    this.element.querySelector(".left-arrow").click();
  }

  close() {
    document.body.style.overflowY = "auto";
    this.element.classList.remove("open");
  }
}
